import batchAxios from './config';
import { batchUrl, legder } from './url';

export const getCompanyList = async (headerData) => {
    return await batchAxios.get(batchUrl.getCompanyList, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const getEledgerLog = async (headerData) => {
    return await batchAxios.get(batchUrl.getEledgerLog, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const createCompany = async (data, headerData) => {
    return await batchAxios.post(batchUrl.createCompanies, data, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const updateLucaCredentials = async (data, headerData) => {
    return await batchAxios.post(batchUrl.updateLucaCredentials, data, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const batchLucaReceipt = async (data, headerData) => {
    return await batchAxios.post(batchUrl.batchLucaReceipt, data, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const batchStatus = async (id, headerData) => {
    return await batchAxios.get(batchUrl.batchStatus + '/' + id + '/status', {
        headers: {
            'X-Company': headerData
        }
    });
};

export const restartFailedSessions = async (data, headerData) => {
    return await batchAxios.post(batchUrl.restartFailedSessions, data, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const getBatchs = async (headerData) => {
    return await batchAxios.get(batchUrl.getBatchs, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const updateSession = async (data, headerData) => {
    return await batchAxios.post(batchUrl.updateSession, data, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const updateCompany = async (data, headerData) => {
    return await batchAxios.post(batchUrl.updateCompany, data, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const sendCertificate = async (data, headerData) => {
    return await batchAxios.post(batchUrl.sendCertificate, data, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const ledgerView = async (data, headerData) => {
    return await batchAxios.post(legder.ledgerView, data, {
        headers: {
            'X-Company': headerData
        }
    });
};

export const reportData = async (data, headerData) => {
    return await batchAxios.post(legder.reportData, data, {
        headers: {
            'X-Company': headerData
        }
    });
};
